import React, { FunctionComponent } from "react";
import { gql, useQuery } from "@shared/utils";
import { Autocomplete, TextField } from "@mui/material";

const ALL_PRODUCTS = gql`
  query Products($parentProductId: String, $allowChildrens: Boolean) {
    products(
      name: ""
      parentProductId: $parentProductId
      allowChildrens: $allowChildrens
    ) {
      _id
      name
    }
  }
`;
type AllProducts = {
  products?: Array<{ _id: string; name: string }>;
};

export const ProductSelect: FunctionComponent<{
  disabled?: boolean;
  productId: string | null;
  parentProductId?: string;
  onChange: (productId: string | null) => void;
}> = ({ productId, onChange, parentProductId , disabled }) => {
  const normalizedProductId =
    productId && productId.length > 0 ? productId : null;
  const ap = useQuery<
    AllProducts,
    { parentProductId?: string; allowChildrens?: boolean }
  >(ALL_PRODUCTS, {
    variables: { parentProductId, allowChildrens: !!parentProductId },
  });
  const options =
    ap.data?.products?.map((p) => {
      return {
        value: p._id,
        label: p.name,
      };
    }) || [];
  if (ap.loading) {
    return <></>;
  }
  const option = options.find((o) => o?.value === normalizedProductId) ?? null;
  return (
    <Autocomplete
      disabled={disabled}
      sx={{ marginTop: 2, marginBottom: 4 }}
      value={option}
      isOptionEqualToValue={(a, b) => a?.value === b?.value}
      onChange={(
        event: any,
        newValue: { value: string; label: string } | null
      ) => {
        onChange(newValue?.value ?? null);
      }}
      id="controllable-states-demo"
      options={options}
      renderInput={(params) => <TextField {...params} label="Product" />}
    />
  );
};
